// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCLcMkToUftfKg0cNkeDt4CQHGHAgLCqCk",
  authDomain: "ksc-ico.firebaseapp.com",
  projectId: "ksc-ico",
  storageBucket: "ksc-ico.firebasestorage.app",
  messagingSenderId: "511496950460",
  appId: "1:511496950460:web:6d70f26dc5d2b326f5f6b9",
  measurementId: "G-ZE801J7M5Y"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
